import { render, staticRenderFns } from "./kanbanone.vue?vue&type=template&id=b293dafe&scoped=true"
import script from "./kanbanone.vue?vue&type=script&lang=js"
export * from "./kanbanone.vue?vue&type=script&lang=js"
import style0 from "./kanbanone.vue?vue&type=style&index=0&id=b293dafe&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b293dafe",
  null
  
)

export default component.exports